/* ============================================================
 * bnz-club-fidelite.js
 * Page « LE CLUB » (fidélité) : handle club-fidelite-makmymask.
 *
 * Les cartes « Bon d'achat » du widget Loyoly (#loyoly-rewards)
 * n'ont qu'un libellé du type « Bon d'achat 10 € dès 49€ d'achat ».
 * La DA veut le montant en très gros (« 10€ ») au-dessus de
 * « en bon d'achat », la condition restant visible en petit.
 *
 * Le widget est rendu par Vue côté client : on ne touche pas à son
 * texte (Vue le réécrirait), on pose seulement des attributs data-*
 * que bnz-club-fidelite.css affiche via ::before / ::after.
 * Un MutationObserver ré-applique le marquage à chaque rendu.
 * ============================================================ */
(function () {
  var VOUCHER = /^bon d['’]achat\s+(\d+(?:[.,]\d+)?)\s*€\s*(.*)$/i;

  function tagVouchers(root) {
    var cards = root.querySelectorAll('.card-reward');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var name = card.querySelector('.lds-card-reward__content--name');
      var texts = card.querySelector('.lds-card-reward__content--texts');
      if (!name || !texts) continue;

      var match = name.textContent.replace(/\s+/g, ' ').trim().match(VOUCHER);
      if (!match) {
        if (card.hasAttribute('data-bnz-voucher')) card.removeAttribute('data-bnz-voucher');
        continue;
      }

      var amount = match[1] + '€';
      var condition = match[2];
      if (card.getAttribute('data-bnz-voucher') === amount && texts.getAttribute('data-bnz-cond') === condition) continue;

      card.setAttribute('data-bnz-voucher', amount);
      name.setAttribute('data-bnz-amount', amount);
      texts.setAttribute('data-bnz-cond', condition);
    }
  }

  function watch() {
    var rewards = document.getElementById('loyoly-rewards');
    if (!rewards) return false;

    tagVouchers(rewards);
    new MutationObserver(function () {
      tagVouchers(rewards);
    }).observe(rewards, { childList: true, subtree: true, characterData: true });
    return true;
  }

  function init() {
    if (watch()) return;

    // Le conteneur Loyoly peut arriver après DOMContentLoaded.
    var bootstrap = new MutationObserver(function () {
      if (watch()) bootstrap.disconnect();
    });
    bootstrap.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
